//@ts-nocheck

import { Modal as ModalAntd, ModalFuncProps} from 'antd';
import React, { useState } from 'react';

interface Props extends ModalFuncProps {
  open?: boolean
  styles?: string
  children: ({ toggleModal, setOpen }) => React.ReactNode
  title?: React.ReactNode | string
  footer?: React.ReactNode | string
  close?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  renderToggle?: ({ toggleModal, setOpen }) => React.ReactNode
};

const Modal = ({ open, styles, close, renderToggle, children }: Props) => {
  const [open_, setOpen] = useState(open);

  const onCancel = () => {
    setOpen(false)
  }

  const toggleModal = () => {
    setOpen(prev => !prev)
  }

  return (
    <>
      <ModalAntd
        visible={open_}
        maskClosable={false}
        onCancel={onCancel}
        className={styles}
        footer={null}
        bodyStyle={{
          padding: '2rem 2rem 2rem',
        }}
        destroyOnClose
      >
        {children && children({ toggleModal, setOpen })}
      </ModalAntd>
      {renderToggle && renderToggle({ toggleModal, setOpen })}
    </>
  );
}

export default Modal;